import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { DependentsTypes } from '../Types';

const machine = Machines.onGetDependents.machine;

export const getDependents = (): Promise<DependentsTypes.IGetDependentsServiceResponse> => {
  return callServiceMachine(machine);
};

export default { getDependents };
